import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const clientsApi = {
  getAll: () => axios.get(`${API}/clients`),
  getOne: (id) => axios.get(`${API}/clients/${id}`),
  create: (data) => axios.post(`${API}/clients`, data),
  update: (id, data) => axios.put(`${API}/clients/${id}`, data),
  delete: (id) => axios.delete(`${API}/clients/${id}`),
};

export const packagesApi = {
  getOptions: () => axios.get(`${API}/packages/options`),
  purchase: (clientId, packageType) => axios.post(`${API}/packages/purchase`, { client_id: clientId, package_type: packageType }),
  getClientPackages: (clientId) => axios.get(`${API}/packages/client/${clientId}`),
};

export const lessonsApi = {
  getAll: (params) => axios.get(`${API}/lessons`, { params }),
  getOne: (id) => axios.get(`${API}/lessons/${id}`),
  create: (data) => axios.post(`${API}/lessons`, data),
  update: (id, data) => axios.put(`${API}/lessons/${id}`, data),
  delete: (id) => axios.delete(`${API}/lessons/${id}`),
  cancel: (id) => axios.post(`${API}/lessons/${id}/cancel`),
  complete: (id) => axios.post(`${API}/lessons/${id}/complete`),
};

export const calendarApi = {
  getMonth: (year, month) => axios.get(`${API}/calendar/month/${year}/${month}`),
  getWeek: (year, month, day) => axios.get(`${API}/calendar/week/${year}/${month}/${day}`),
};

export const trainingPlansApi = {
  create: (data) => axios.post(`${API}/training-plans`, data),
  getByClient: (clientId) => axios.get(`${API}/training-plans/client/${clientId}`),
  getExpired: (clientId) => axios.get(`${API}/training-plans/expired/${clientId}`),
  acknowledge: (id) => axios.post(`${API}/training-plans/${id}/acknowledge`),
  delete: (id) => axios.delete(`${API}/training-plans/${id}`),
};

export const dashboardApi = {
  getStats: () => axios.get(`${API}/dashboard/stats`),
};
